export default __webpack_public_path__ + "media/7b5f01ba8d5f9e9987b5b3df74a3d924fb5ec17b0eb389db17272d76f9c9e58f.svg";